<template>
  <span class="status-badge" :class="colorClass">{{ label }}</span>
</template>

<script setup>
import { computed } from 'vue'
import { workReportStatusMeta } from '../workReportUtils'

const props = defineProps({
  status: {
    type: String,
    default: ''
  }
})

const currentStatus = computed(() => workReportStatusMeta(props.status))
const label = computed(() => currentStatus.value.label)
const colorClass = computed(() => currentStatus.value.color)
</script>
